import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import MemberLocationPreview from '../../../components/MemberLocationPreview';
import { ADDRESS_TYPES } from '../../../utils/calendar';
import { connect } from 'react-redux';

const MemberLocationSelect = ({ value, handleChange, locationObjects }) => {
  console.debug('MemberLocationSelect', locationObjects, value);

  return !!locationObjects && !!locationObjects[0] ? (
    <FormControl
      fullWidth
      variant="outlined"
      margin="dense"
      style={{ margin: 0 }}
    >
      <InputLabel id="label-my-locations">My locations</InputLabel>
      <Select
        labelId="label-my-locations"
        id="event-location-type-select"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        label="My locations"
      >
        {locationObjects.map((lo) => (
          <MenuItem
            key={lo.id}
            value={lo}
            // style={{ paddingTop: '4px', paddingBottom: '4px' }}
          >
            <MemberLocationPreview data={lo} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : (
    <TextField
      value="Your Location List is Empty"
      // disabled
      fullWidth
      variant="outlined"
      margin="dense"
      style={{ margin: 0 }}
    />
  );
};

// Don't show Billing addresses
const mapStateToProps = (state) => ({
  locationObjects: state.member.memberInfo.location_information.filter(
    (lo) => lo && lo.location_type !== ADDRESS_TYPES.billing
  ),
});

export default connect(mapStateToProps)(MemberLocationSelect);
